<template>
    <ul id="tools_list">
        <router-link tag="li" to="/tools" exact>
            <a class="side-menu"><span></span><package-icon></package-icon><p>Tools</p></a>
        </router-link>
        <router-link tag="li" to="/tools/urls">
            <a class="side-menu"><span></span><alert-triangle-icon></alert-triangle-icon><p>URLs Checker</p></a>
        </router-link>
        <router-link tag="li" to="/tools/compare">
            <a class="side-menu"><span></span><search-icon></search-icon><p>Compare</p></a>
        </router-link>
    </ul>
</template>

<script>
    import { PackageIcon, AlertTriangleIcon, SearchIcon } from 'vue-feather-icons'
    import SearchInput from "@/components/small/SearchInput";

    export default {
        name: "ToolsSideMenu",
        components: {
            SearchInput,
            //Feather icons
            PackageIcon, AlertTriangleIcon, SearchIcon
        }
    }
</script>

<style scoped>
    ul{
        border-bottom: 1px solid #e9eff3;
    }

    ul li{
        padding: 0;
        box-shadow: 0px 2px 3px #000000;
        position: relative;
        z-index: 100;
        transition: 0.3s;
        margin: 0;
    }

    ul li a{
        margin: 0;
        margin-left: 1px;
        margin-right: 1px;
        padding: 0.5em;
        display: block;
    }

    .router-link-exact-active{
        margin: 0;
        background: #bdc3c7;
        /*background: linear-gradient(to top, #ff7a2c, #bdc3c7, #bdc3c7,#bdc3c7, #83a8be);*/
        background: linear-gradient(to top, #ff7a2c, #ffaf4f);
        border: 0;
        border-left: 1px solid #712323;
        border-right: 1px solid #d04242;
        box-sizing: border-box;
        z-index: 10;
        transition: z-index 0.3s;
    }

    .router-link-exact-active:hover{
        background: linear-gradient(to top, #ff7a2c, #ffaf4f);
    }

    .router-link-exact-active a{
        margin: 0;
        border-left: 1px solid #526775;

        border-bottom: 1px solid #425360;
        text-decoration: none;
        width: 100%;
        box-sizing: border-box;
        border: 0;
        padding: calc(0.5rem + 1.5px);
        box-shadow: inset 0px 0px 5px 2px #d04242;
        transition: 0.3s;
    }

    .side-menu{
        display: flex;
        flex-direction: column;
        align-items: center;
        align-content: center;
        justify-items: center;
    }

    ul li:hover{
        background: linear-gradient(to top, #769ab0, #acb2b6);
    }

    .side-menu svg{
        margin: 0.2rem;
        color: #ffffff;
        -webkit-filter: drop-shadow( 0px 0px 0px rgba(0, 0, 0, 0));
        filter: drop-shadow( 0px 0px 0px rgba(0, 0, 0, 0));
        transition: 0.3s;
    }

    .router-link-exact-active svg, ul li:hover svg{
        color: rgb(255,0,55);
        filter: drop-shadow( -4px 4px 2px #000000);
        transition: ease-in 0.3s;
    }

    .router-link-exact-active a p{
        width: 100%;
        text-align: center;
        text-shadow: none;
    }

    .router-link-exact-active a span{
        box-shadow: -4px 4px 4px #000000;
        background-color: #e72238;
        transition: ease 0.3s;
    }

    .side-menu:hover span{
        animation: move 1s ease 0s infinite;
        animation-fill-mode: forwards;
        box-shadow: none;
    }

    /*.side-menu:hover a{*/
        /*animation: shadows 0.5s ease 0s 1;*/
        /*animation-fill-mode: both;*/
    /*}*/

    li.router-link-exact-active:hover span{
    }

    @keyframes glitch {
        0% {
            position: relative;
            display: inline-block;
        }

        10% {
            transform: scale(4);
        }

        15% {
            transform: scale(1)
        }

        22% {
            transform: scale(3);
            opacity: 1;
        }

        25%{
            transform: scale(1);
            opacity: 0;
        }

        28% {
            transform: scale(2);
            opacity: 1;
        }

        31%{
            transform: scale(0.7);
        }

        33%{
            transform: scale(1.5);
            opacity: 1;
        }

        34%{
            opacity: 0;
            transform: scale(0.1);
        }

        36%{
            opacity: 1;
            transform: scale(1);
        }

        100%{
            opacity: 1;
        }
    }

    @keyframes move {
        0% {
            position: relative;
            display: inline-block;
            margin-top: 0.2rem;
            margin-bottom: 0.2rem;
            transform: rotate3d(0,0,0, 0deg);
            background-color: #ffffff;
        }

        /*10% {*/
            /*margin-top: -1.2rem;*/
            /*margin-bottom: 1.6rem;*/
        /*}*/

        /*15% {*/
            /*margin-top: 0.2rem;*/
            /*margin-bottom: 0.2rem;*/
        /*}*/

        /*22% {*/
            /*margin-top: -0.9rem;*/
            /*margin-bottom: 1.3rem;*/
        /*}*/

        /*25%{*/
            /*margin-top: 0.2rem;*/
            /*margin-bottom: 0.2rem;*/
        /*}*/

        /*28% {*/
            /*margin-top: -0.7rem;*/
            /*margin-bottom: 1.1rem;*/
        /*}*/

        /*31%{*/
            /*margin-top: 0.2rem;*/
            /*margin-bottom: 0.2rem;*/
        /*}*/

        /*33%{*/
            /*margin-top: -0.5rem;*/
            /*margin-bottom: 0.9rem;*/
        /*}*/

        /*34%{*/
            /*margin-top: 0.2rem;*/
            /*margin-bottom: 0.2rem;*/
        /*}*/

        /*36%{*/
            /*margin-top: -0.3rem;*/
            /*margin-bottom: 0.7rem;*/
        /*}*/

        37%{
            margin-top: 0.2rem;
            margin-bottom: 0.2rem;
        }

        50%{
            background-color: #e72238;
            transform: rotate3d(0,1,0,180deg);
        }

        100%{
            background-color: #ffffff;
            margin-top: 0.2rem;
            margin-bottom: 0.2rem;
        }
    }

    @keyframes shadows {
        0%{
            text-shadow: -1px 1px 0px #425360;
        }

        100%{
            text-shadow: 0px 0px 0px #425360;
        }
    }

    .side-menu.router-link-exact-active p{
        width: 100%;
        text-align: center;
    }
</style>
